module.exports = __webpack_public_path__ + "img/ZZRY_15.8e504566.jpg";